<template>
    <div>
        <div ref="presenterAvailabilityErrorSummary">
            <section v-if="form_submitted">
                <div class="container">
                    <div class="alert alert-danger">
                        <ul>
                            <li
                                class="text-danger"
                                v-for="error in errors"
                                :key="error"
                            >
                                {{ error }}
                            </li>
                        </ul>
                    </div>
                </div>
            </section>
        </div>

        <div class="container scroll-sm">
            <fieldset style="min-width: 850px">
                <legend>Days of Attendance &amp; Time slots</legend>
                <p
                    class="font-9"
                    v-html="conferenceTextData.presenter_slots_instruction_text"
                ></p>
                <div
                    v-if="!hideTimeZone"
                    style="
                        display: block;
                        margin-bottom: 1rem;
                        width: 50%;
                        position: relative;
                    "
                >
                    <div
                        class="absolute-full"
                        v-if="fireAlert && !(afterCutoff || duringCutoff)"
                        @click="showConfirm"
                    ></div>
                    <VueSelect
                        placeholder="Select Time Zone"
                        :options="this.timeZones"
                        @input="changeTimeZone"
                        :value="this.default_timezone"
                        :disabled="true"
                    ></VueSelect>
                </div>
                <!-- timezone selected -->
                <div>
                    <div v-if="this.selectedTimeZone.code">
                        <div
                            v-for="group in groupedSlots"
                            :key="group.groupNumber"
                        >
                            <div
                                @click="selectGroup(group)"
                                style="margin-bottom: 10px"
                            >
                                <input
                                    v-model="selected_group"
                                    type="radio"
                                    :value="group.groupNumber"
                                    @click="showConfirm"
                                    :disabled="afterCutoff || duringCutoff"
                                />
                                <b>
                                    {{ group.groupTitle }}
                                </b>
                            </div>
                            <div v-if="selected_group == group.groupNumber">
                                <div
                                    style="margin-bottom: 10px; display: flex"
                                    v-for="(val, date, index) in group.slots"
                                    :key="date"
                                >
                                    <input
                                        v-model="available_slot"
                                        @click="showConfirm"
                                        type="checkbox"
                                        :value="date"
                                        :disabled="
                                            isSlotDisabled(index, date) ||
                                            isInLateRegister(date) ||
                                            duringCutoff
                                        "
                                        @change="
                                            selectPresenterSlot(date, $event)
                                        "
                                    />
                                    {{ val.formattedDate }}
                                    <div style="display: flex; margin: 0px 6px">
                                        <div style="margin: 0px 4px">
                                            <input
                                                :id="'all' + val.formattedDate"
                                                :checked="
                                                    isAllSelected(val.timeslots)
                                                "
                                                :disabled="
                                                    isSlotDisabled(
                                                        index,
                                                        date
                                                    ) ||
                                                    isInLateRegister(date) ||
                                                    duringCutoff
                                                "
                                                @change="
                                                    selectAllPresenterSlots(
                                                        $event,
                                                        val.timeslots,
                                                        val.formattedDate
                                                    )
                                                "
                                                type="checkbox"
                                                @click="showConfirm"
                                                style="margin: unset"
                                                :value="date"
                                            />
                                            <span> All </span>
                                        </div>
                                        <!-- str morning & afternoon -->
                                        <div
                                            style="display: flex"
                                            :style="
                                                !notTheFirstDay(date)
                                                    ? 'flex-direction: row; padding-left: 6px;'
                                                    : 'flex-direction: column;'
                                            "
                                        >
                                            <!-- str morning -->
                                            <div
                                                style="
                                                    display: flex;
                                                    flex-direction: row;
                                                "
                                                v-if="
                                                    val.morning_slots.length > 0
                                                "
                                            >
                                                <div
                                                    style="
                                                        margin: 0px 20px 0 10px;
                                                    "
                                                    v-if="notTheFirstDay(date)"
                                                >
                                                    <input
                                                        :id="
                                                            'morningSelector' +
                                                            val.formattedDate
                                                        "
                                                        :checked="
                                                            isAllSelected(
                                                                val.morning_slots
                                                            )
                                                        "
                                                        :disabled="
                                                            isSlotDisabled(
                                                                index,
                                                                date
                                                            ) ||
                                                            isInLateRegister(
                                                                date
                                                            ) ||
                                                            duringCutoff
                                                        "
                                                        @change="
                                                            selectAllPresenterSlots(
                                                                $event,
                                                                val.morning_slots,
                                                                val.formattedDate
                                                            )
                                                        "
                                                        type="checkbox"
                                                        @click="showConfirm"
                                                        style="margin: unset"
                                                        :value="date"
                                                    />
                                                    <span> Morning </span>
                                                </div>
                                                <!-- Morning slots -->
                                                <div
                                                    class="toltip-wrapper"
                                                    style="margin: 0px 4px"
                                                    v-for="timeslot in val.morning_slots"
                                                    :key="
                                                        'slotstart' +
                                                        timeslot.start_time
                                                    "
                                                >
                                                    <input
                                                        :id="
                                                            'morningSlots' +
                                                            val.formattedDate
                                                        "
                                                        :disabled="
                                                            isSlotDisabled(
                                                                index,
                                                                date
                                                            ) ||
                                                            isInLateRegister(
                                                                date
                                                            ) ||
                                                            duringCutoff ||
                                                            exceedMaxCapacity(
                                                                timeslot.id
                                                            ) ||
                                                            !validateMorningOrAfternoonSelectionPerDay(
                                                                date
                                                            )
                                                        "
                                                        type="checkbox"
                                                        style="margin: unset"
                                                        @click="showConfirm"
                                                        v-model="
                                                            presenter_slots
                                                        "
                                                        :value="timeslot.id"
                                                        :class="{
                                                            'back-red':
                                                                exceedMaxCapacity(
                                                                    timeslot.id
                                                                ),
                                                        }"
                                                    />
                                                    <span
                                                        v-if="
                                                            exceedMaxCapacity(
                                                                timeslot.id
                                                            )
                                                        "
                                                        class="toltip"
                                                    >
                                                        Please note that this
                                                        slot is fully booked.
                                                        Please choose other
                                                        slots within the same
                                                        day or change your days
                                                        of attendance.
                                                    </span>
                                                    <span
                                                        v-if="
                                                            !validateMorningOrAfternoonSelectionPerDay(
                                                                date
                                                            )
                                                        "
                                                        class="toltip"
                                                    >
                                                        <span
                                                            v-if="
                                                                !notTheFirstDay(
                                                                    date
                                                                )
                                                            "
                                                        >
                                                            Please select all
                                                            slots first!
                                                        </span>
                                                        <span v-else>
                                                            Please select
                                                            morning or afternoon
                                                            first then you can
                                                            select additional
                                                            slots from the other
                                                            part of the day.
                                                        </span>
                                                    </span>
                                                    <span>
                                                        {{
                                                            timeslot.start_time
                                                        }}
                                                    </span>
                                                </div>
                                            </div>
                                            <!-- end morning -->

                                            <!-- str afternoon -->
                                            <div
                                                style="
                                                    display: flex;
                                                    flex-direction: row;
                                                "
                                                v-if="
                                                    val.afternoon_slots.length >
                                                    0
                                                "
                                            >
                                                <div
                                                    style="
                                                        margin: 0px 8px 0 10px;
                                                    "
                                                    v-if="notTheFirstDay(date)"
                                                >
                                                    <input
                                                        :id="
                                                            'afternoonSelector' +
                                                            val.formattedDate
                                                        "
                                                        :checked="
                                                            isAllSelected(
                                                                val.afternoon_slots
                                                            )
                                                        "
                                                        :disabled="
                                                            isSlotDisabled(
                                                                index,
                                                                date
                                                            ) ||
                                                            isInLateRegister(
                                                                date
                                                            ) ||
                                                            duringCutoff
                                                        "
                                                        @change="
                                                            selectAllPresenterSlots(
                                                                $event,
                                                                val.afternoon_slots,
                                                                val.formattedDate
                                                            )
                                                        "
                                                        type="checkbox"
                                                        @click="showConfirm"
                                                        style="margin: unset"
                                                        :value="date"
                                                    />
                                                    <span> Afternoon </span>
                                                </div>
                                                <!-- Afternoon slots -->
                                                <div
                                                    class="toltip-wrapper"
                                                    style="margin: 0px 4px"
                                                    v-for="timeslot in val.afternoon_slots"
                                                    :key="
                                                        'slotstart' +
                                                        timeslot.start_time
                                                    "
                                                >
                                                    <input
                                                        :id="
                                                            'afternoonSlots' +
                                                            val.formattedDate
                                                        "
                                                        :disabled="
                                                            isSlotDisabled(
                                                                index,
                                                                date
                                                            ) ||
                                                            isInLateRegister(
                                                                date
                                                            ) ||
                                                            duringCutoff ||
                                                            exceedMaxCapacity(
                                                                timeslot.id
                                                            ) ||
                                                            !validateMorningOrAfternoonSelectionPerDay(
                                                                date
                                                            )
                                                        "
                                                        type="checkbox"
                                                        style="margin: unset"
                                                        @click="showConfirm"
                                                        v-model="
                                                            presenter_slots
                                                        "
                                                        :value="timeslot.id"
                                                        :class="{
                                                            'back-red':
                                                                exceedMaxCapacity(
                                                                    timeslot.id
                                                                ),
                                                        }"
                                                    />
                                                    <span
                                                        v-if="
                                                            exceedMaxCapacity(
                                                                timeslot.id
                                                            )
                                                        "
                                                        class="toltip"
                                                    >
                                                        Please note that this
                                                        slot is fully booked.
                                                        Please choose other
                                                        slots within the same
                                                        day or change your days
                                                        of attendance.
                                                    </span>
                                                    <span
                                                        v-if="
                                                            !validateMorningOrAfternoonSelectionPerDay(
                                                                date
                                                            )
                                                        "
                                                        class="toltip"
                                                    >
                                                        <span
                                                            v-if="
                                                                !notTheFirstDay(
                                                                    date
                                                                )
                                                            "
                                                        >
                                                            Please select all
                                                            slots first!
                                                        </span>
                                                        <span v-else>
                                                            Please select
                                                            morning or afternoon
                                                            first then you can
                                                            select additional
                                                            slots from the other
                                                            part of the day.
                                                        </span>
                                                    </span>
                                                    <span>
                                                        {{
                                                            timeslot.start_time
                                                        }}
                                                    </span>
                                                </div>
                                            </div>
                                            <!-- end afternoon -->
                                        </div>
                                        <!-- end morning & afternoon -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- No selected timezone -->
                    <div>
                        <span
                            >Please note that there is limited availability on
                            each slot, so please make sure to select the time
                            slots that you can attend so we can schedule your
                            meetings accordingly</span
                        >
                        <p class="font-bold font-9" style="margin-bottom: 0px">
                            If you require further assistance, please email us
                            at
                            <a
                                :href="
                                    'mailto:' +
                                    conferenceTextData.conference_email
                                "
                                class="text_underline"
                            >
                                {{ conferenceTextData.conference_email }}
                            </a>
                        </p>
                    </div>
                </div>
            </fieldset>
        </div>
    </div>
</template>

<script>
import Layout from "@/components/layouts/Layout.vue";
import { mapState, mapGetters } from "vuex";
import VueSelect from "vue-select";
import Api from "@/Api";

var momentTZ = require("moment-timezone");
var moment = require("moment");

export default {
    name: "presenter-availability-page",
    components: {
        Layout,
        VueSelect,
    },
    data() {
        return {
            form_submitted: false,
            disable_submit: false,
            hideTimeZone: true,
            fireAlert: false,
            errors: [],
            agenda_slots: [],
            closed_days: [],
            available_slot: [],
            old_available_slot: [],
            presenter_slots: [],
            conference: {},
            conference_dates: [],
            selected_group: 0,
            selectedTimeZone: {},
            default_timezone: {
                label:
                    "Europe/London" +
                    " (GMT" +
                    momentTZ.tz("Europe/London").format("Z") +
                    ")",
                code: "Europe/London",
            },
            minimum_slots_for_presenters: JSON.parse(
                localStorage.getItem("conference")
            ).minimum_slots_for_presenters,
            slots_attendance: [],
            registered_client_company_id: JSON.parse(
                localStorage.getItem("registeration.client")
            ).client.company_id,
            noDrop: true,
        };
    },
    methods: {
        init() {
            console.log("Default timezone", this.selectedTimeZone);

            const presenter_mates = JSON.parse(
                localStorage.getItem("registeration.presenter_mates")
            ).filter((mate) => mate.status == 2);

            const client_all_data = JSON.parse(
                localStorage.getItem("registeration.client")
            );
            this.conference_dates = JSON.parse(
                localStorage.getItem("registeration.conference_dates")
            );
            let lists = JSON.parse(localStorage.getItem("registeration.lists"));

            this.getCutOffDate();

            setTimeout(() => {
                let conference = JSON.parse(localStorage.getItem("conference"));
                this.conference = conference;
            }, 500);

            // set data for presenter if he have registered colleagues
            if (presenter_mates && presenter_mates.length > 0) {
                // show the warning message to presenter 
                this.fireAlert = true;
                client_all_data.available_slot =
                    client_all_data.available_slot.length > 0
                        ? client_all_data.available_slot
                        : presenter_mates[0].available_slot;

                client_all_data.presenter_property.available_slot =
                    client_all_data.presenter_property.available_slot.length > 0
                        ? client_all_data.presenter_property.available_slot
                        : presenter_mates[0].presenter_property.available_slot;
            }

            this.agenda_slots = lists.agenda_slots ? lists.agenda_slots : [];
            this.closed_days = lists.closed_days ? lists.closed_days : [];
            this.old_available_slot = this.available_slot = Array.isArray(client_all_data.available_slot)
                ? client_all_data.available_slot
                : [];
            const slots = client_all_data.presenter_property
                ? client_all_data.presenter_property.available_slot.map(
                      (item) => Number(item)
                  )
                : [];
            this.presenter_slots = slots;
            // let timezone = client_all_data.timezone
            //     ? {
            //           label:
            //               client_all_data.timezone +
            //               " (GMT" +
            //               momentTZ.tz(client_all_data.timezone).format("Z") +
            //               ")",
            //           code: client_all_data.timezone
            //       }
            //     : presenter_mates.length > 0
            //     ? {
            //           label:
            //               presenter_mates[0].timezone +
            //               " (GMT" +
            //               momentTZ.tz(presenter_mates[0].timezone).format("Z") +
            //               ")",
            //           code: presenter_mates[0].timezone
            //       }
            //     : {
            //           label: "Please select your timezone",
            //           code: ""
            //       };
            // if (client_all_data.timezone || presenter_mates.length > 0) {
            //     this.changeTimeZone(timezone);
            // }
            let timezone = this.default_timezone;
            this.changeTimeZone(timezone);
            this.selectedTimeZone = timezone;
        },

        selectGroup(group) {
            if (this.fireAlert) {
                return;
            }
            if (this.afterCutoff || this.duringCutoff) return;
            this.available_slot = [];
            this.presenter_slots = [];
            _.each(group.slots, (slots, date) => {
                this.available_slot.push(date);
            });
        },

        isSlotDisabled(index, date) {
            if (!this.selected_group) return false;
            if (this.available_slot.includes(date)) return false;
            let conference_dates = this.groupedSlots
                .map((group) => Object.keys(group.slots))
                .flat();
            conference_dates = conference_dates.reduce(
                (acc, curr) => ({
                    ...acc,
                    [curr]: conference_dates.indexOf(curr) + 1,
                }),
                {}
            );
            const dayNumber = conference_dates[date];
            let slotGroup = Math.ceil(dayNumber / this.conference.split_days);
            return slotGroup !== this.selected_group;
        },

        exceedMaxCapacity(id) {
            if (this.slots_attendance.length <= 0) return false;
            return (
                this.slots_attendance[`${id}`] &&
                this.slots_attendance[`${id}`].disabled &&
                !this.slots_attendance[`${id}`].companiesIds.includes(
                    this.registered_client_company_id
                )
            );
        },

        isInLateRegister(date) {
            const lateRegisterAvailableSLots = localStorage.getItem(
                "lateRegisterAvailableSLots"
            );
            let lateRegisterList;
            if (
                lateRegisterAvailableSLots &&
                lateRegisterAvailableSLots != "undefined"
            ) {
                lateRegisterList = JSON.parse(lateRegisterAvailableSLots);
            }
            if (!lateRegisterList || _.isEmpty(lateRegisterList)) return false;
            return true;
        },

        selectPresenterSlot(date, ev) {
            if (ev == true || ev.target.checked) {
                const dayNumber = this.conference_dates[date];
                this.selected_group = Math.ceil(
                    dayNumber / this.conference.split_days
                );
            } else {
                let selectedGroup = this.groupedSlots.filter((group) => {
                    return group.slots[date];
                });
                const slotsIds = selectedGroup[0].slots[date].timeslots.map(
                    (timeslot) => timeslot.id
                );
                this.presenter_slots = this.presenter_slots.filter(
                    (id) => !slotsIds.includes(id)
                );

                if (!(this.available_slot && this.available_slot.length))
                    this.selected_group = 1;
            }
        },

        selectAllPresenterSlots(e, slots, date = null) {
            let el = e.target;
            let checkboxes = document.querySelectorAll("input[type=checkbox]");

            let slots_ids = slots
                .map((slot) => slot.id)
                .filter((slot) => !this.exceedMaxCapacity(slot));

            if (el.checked == true) {
                this.presenter_slots = _.uniq([
                    ...this.presenter_slots,
                    ...slots_ids,
                ]);

                checkboxes.forEach((checkbox) => {
                    if (slots_ids.includes(parseInt(checkbox.value))) {
                        checkbox.classList.add("dimmed");
                    }
                });
            } else {
                this.presenter_slots = this.presenter_slots.filter(
                    (item) => !slots_ids.includes(item)
                );

                checkboxes.forEach((checkbox) => {
                    if (slots_ids.includes(parseInt(checkbox.value))) {
                        checkbox.classList.remove("dimmed");
                    }
                });

                // clear all selected slots per day if user unselect morning or afternoon
                if (date) this.clearSelectedSlotsInThisDay(date);
            }
        },

        isAllSelected(timeSlots) {
            const timeSlotsId = timeSlots
                .map((slot) => slot.id)
                .filter((slot) => !this.exceedMaxCapacity(slot));
            const intersectionLength = _.intersection(
                this.presenter_slots,
                timeSlotsId
            ).length;
            return intersectionLength === timeSlotsId.length;
        },

        checkSlotIntersection(timeslots) {
            let slots_ids = timeslots
                    .map((slot) => slot.id)
                    .filter((slot) => !this.exceedMaxCapacity(slot)),
                intersection = _.intersection(slots_ids, this.presenter_slots);

            if (slots_ids.length > 0 && intersection.length == slots_ids.length)
                return true;

            return false;
        },

        disableSelectedSlots() {
            if (!this.selected_group) return;

            let morning_slots_ids,
                afternoon_slots_ids,
                currentGroup = this.groupedSlots[this.selected_group - 1],
                checkboxes = document.querySelectorAll(
                    "input[type=checkbox]:checked"
                );

            // - loop over days of selected group
            for (const [key, value] of Object.entries(currentGroup.slots)) {
                if (this.checkSlotIntersection(value.morning_slots)) {
                    checkboxes.forEach((checkbox) => {
                        morning_slots_ids = value.morning_slots.map(
                            (slot) => slot.id
                        );
                        if (
                            morning_slots_ids.includes(parseInt(checkbox.value))
                        ) {
                            checkbox.classList.add("dimmed");
                        }
                    });
                }

                if (this.checkSlotIntersection(value.afternoon_slots)) {
                    checkboxes.forEach((checkbox) => {
                        afternoon_slots_ids = value.afternoon_slots.map(
                            (slot) => slot.id
                        );
                        if (
                            afternoon_slots_ids.includes(
                                parseInt(checkbox.value)
                            )
                        ) {
                            checkbox.classList.add("dimmed");
                        }
                    });
                }
            }
        },

        mapSelectedGroup(available_dates) {
            if (this.afterCutoff) {
                this.mapSelectedGroupAfterCutoffDate();
                return;
            }
            this.groupedSlots.forEach((group) => {
                let keys = Object.keys(group.slots);
                if (_.intersection(available_dates, keys).length >= 1) {
                    this.selected_group = group.groupNumber;
                }
            });
        },

        mapSelectedGroupAfterCutoffDate() {
            const lateRegisterAvailableSLots = localStorage.getItem(
                "lateRegisterAvailableSLots"
            );
            let lateRegisterList;
            if (
                lateRegisterAvailableSLots &&
                lateRegisterAvailableSLots != "undefined"
            ) {
                lateRegisterList = JSON.parse(
                    localStorage.getItem("lateRegisterAvailableSLots")
                );
                let keys = Object.keys(lateRegisterList);
                this.groupedSlots.map((group) => {
                    if (group.slots[keys[0]]) {
                        this.selected_group = group.groupNumber;
                        keys.map((key) => {
                            this.presenter_slots.push(
                                ...lateRegisterList[key].map((slot) => slot.id)
                            );
                            return key;
                        });
                    }
                });
                this.available_slot = keys;
            }
        },

        showConfirm(e) {
            if (this.fireAlert) {
                this.$swal({
                    html: '<p style="color:red">Please note that any changes to your days of attendance will affect all delegates who are registered from your company.</p>',
                    showCancelButton: true,
                    confirmButtonText: "OK",
                    position: "center",
                    width: "45rem",
                    customClass: {
                        actions: "flex justify-end",
                    },
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.fireAlert = false;
                        return false;
                    }
                });
                if (e) e.preventDefault();
            }
        },

        numberOfSlotsAvailableInSelectedDay(slotId) {
            let selectedDay;
            let disabledSlots = [];
            for (const slot in this.slots_attendance) {
                if (this.slots_attendance[slot].disabled)
                    disabledSlots.push(slot);
            }
            this.groupedSlots.forEach((group) => {
                for (const date in group.slots) {
                    const res = group.slots[date].timeslots.find(
                        (slot) => slot.id === slotId
                    );
                    if (res) selectedDay = group.slots[date];
                }
            });

            const availableSlots = selectedDay.timeslots.filter(
                (slot) => slot.id != disabledSlots.find((s) => s == slot.id)
            ).length;
            return {
                ...selectedDay,
                availableSlots,
            };
        },

        validateMinimumSlotsPerPresenterCap() {
            let valid = true;
            // check how many slots are available in the selected day
            this.presenter_slots.forEach((slotSelected) => {
                let selectedDay =
                    this.numberOfSlotsAvailableInSelectedDay(slotSelected);
                let availableSlotsInSelectedDay = selectedDay.availableSlots;
                if (
                    availableSlotsInSelectedDay >=
                    this.minimum_slots_for_presenters
                ) {
                    // check if user selected at least minimum cap slots in this day
                    let selectedSlotsInDay = selectedDay.timeslots
                        .filter(
                            (slot) =>
                                slot.id ==
                                this.presenter_slots.find((s) => s == slot.id)
                        )
                        .map((slot) => slot.id);
                    if (
                        selectedSlotsInDay.length <
                        this.minimum_slots_for_presenters
                    )
                        valid = false;
                }
            });

            return valid;
        },

        validateMorningOrAfternoonSelectionPerDay(day) {
            let currentDaySlots =
                this.groupedSlots[this.selected_group - 1].slots[day];

            if (
                this.checkSlotIntersection(currentDaySlots.morning_slots) ||
                this.checkSlotIntersection(currentDaySlots.afternoon_slots)
            )
                return true;

            return false;
        },

        clearSelectedSlotsInThisDay(date) {
            // console.log(date);

            // clear morning slots
            document
                .querySelectorAll("#morningSlots" + date)
                .forEach((morningSlot) => {
                    morningSlot.checked = false;
                    morningSlot.classList.remove("dimmed");
                    let index = this.presenter_slots.findIndex((slot) => {
                        return slot == morningSlot.value;
                    });
                    if (index >= 0) this.presenter_slots.splice(index, 1);
                });

            // clear afternoon slots
            document
                .querySelectorAll("#afternoonSlots" + date)
                .forEach((afternoonSlot) => {
                    afternoonSlot.checked = false;
                    afternoonSlot.classList.remove("dimmed");
                    let index = this.presenter_slots.findIndex((slot) => {
                        return slot == afternoonSlot.value;
                    });
                    if (index >= 0) this.presenter_slots.splice(index, 1);
                });
        },

        notTheFirstDay(date) {
            if (date == Object.keys(this.agenda_slots)[0]) return false;

            return true;
        },

        validateMorningOrAfternoonSelection() {
            if (this.afterCutoff || this.duringCutoff) return true;

            let all,
                morning,
                afternoon,
                selectedGroupIndex = this.selected_group - 1,
                selectedGroupSlots =
                    this.groupedSlots[selectedGroupIndex].slots;

            for (const [key, value] of Object.entries(selectedGroupSlots)) {
                all = document.getElementById("all" + value.formattedDate);
                morning = document.getElementById(
                    "morningSelector" + value.formattedDate
                );
                afternoon = document.getElementById(
                    "afternoonSelector" + value.formattedDate
                );

                if (
                    (all && all.checked) ||
                    (morning && morning.checked) ||
                    (afternoon && afternoon.checked)
                )
                    return true;
            }

            return false;
        },

        validate() {
            const errors = [];
            let valid = true;

            if (this.selectedTimeZone.code === "") {
                errors.push("Timezone Required");
                valid = false;
            }

            if (this.available_slot.length <= 0) {
                errors.push("Available Slots Required");
                valid = false;
            }

            if (this.presenter_slots.length <= 0) {
                errors.push("Slots per Day Required");
                valid = false;
            }

            if (!this.validateMinimumSlotsPerPresenterCap()) {
                errors.push(
                    `You need to select at least ${this.minimum_slots_for_presenters} slots per day so your attendance can be confirmed.`
                );
                valid = false;
            }

            if (!this.validateMorningOrAfternoonSelection()) {
                errors.push(
                    `You need to select at least all morning or afternoon slots per day so your attendance can be confirmed.`
                );
                valid = false;
            }

            this.validateValidSlots();

            this.errors = errors;
            return valid;
        },

        validateValidSlots() {
            this.presenter_slots = this.presenter_slots.filter((slotId) => {
                return !this.exceedMaxCapacity(slotId);
            });
        },

        scrollToFirstError() {
            const el = this.$refs.presenterAvailabilityErrorSummary;
            if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
        },

        submitAndRegister(presenterData, presenterMates) {
            if (this.disable_submit) return;

            if (this.presenter_slots.length == 0) {
                alert(
                    "Please select your preferred days of attendance and time slots before you submit your application."
                );
                return;
            }

            if (!this.validate()) {
                this.form_submitted = true;
                this.scrollToFirstError();
                return;
            }

            this.form_submitted = false;
            this.disable_submit = true;

            presenterData.timezone = this.selectedTimeZone.code;

            const mates = presenterMates.map((mate) => {
                return {
                    ...mate.mateFormData,
                    conf_client_id: mate.mateId,
                    available_slot: this.presenter_slots,
                    timezone: this.selectedTimeZone.code,
                    registered_by: JSON.parse(
                        localStorage.getItem("registeration.client")
                    ).client_id,
                };
            });

            this.registerPresenter(presenterData, mates);
        },

        registerPresenter(data, mates) {
            data.available_slot = this.presenter_slots;
            data.timezone = this.selectedTimeZone.code;

            Api()
                .post("auth/signup", data)
                .then((res) => {
                    // register presenter mates
                    mates.map((mate) => this.registerMateApi(mate));

                    let firstRegisterTime = localStorage.getItem(
                        "firstTimeRegister"
                    )
                        ? parseInt(localStorage.getItem("firstTimeRegister"))
                        : 0;

                    firstRegisterTime
                        ? this.$router.push({ name: "Thank" })
                        : this.$router.push({ name: "ThankAfterRegistration" });
                })
                .catch((err) => {
                    this.disable_submit = false;
                    console.log("error", err);
                });
        },

        getSlotsAttendancePercentage() {
            Api()
                .get(
                    `auth/slots-attendance-percentage/${process.env.VUE_APP_CONFERENCE_ID}`
                )
                .then((res) => {
                    if (res.data.slotsAttendance.length <= 0) {
                        console.log("empty slots");
                        return;
                    }
                    this.total_count = res.data.count;
                    const presenterCompanyPriority =
                        res.data.companiesPriorities[
                            this.registered_client_company_id
                        ];
                    this.calcSlotsAttendancePrecentage(
                        res.data.slotsAttendance,
                        res.data.count,
                        presenterCompanyPriority
                    );
                })
                .catch((err) => {
                    console.log("error", err);
                    console.log("error response", err.response);
                });
        },

        calcSlotsAttendancePrecentage(
            slots,
            totalCount,
            presenterCompanyPriority
        ) {
            let conference = JSON.parse(localStorage.getItem("conference"));
            const maxSlotCapacity = conference.presenter_slot_capacity;
            let keys = Object.keys(slots);
            keys.forEach((key) => {
                slots[key] = {
                    capacity: slots[key].capacity,
                    companiesIds: slots[key].ids,
                    disabled:
                        maxSlotCapacity > 0 &&
                        maxSlotCapacity <
                            slots[key].capacity +
                                (presenterCompanyPriority || 1)
                            ? true
                            : false,
                };
            });
            this.slots_attendance = slots;
        },

        registerMateApi(mate) {
            Api()
                .post("auth/register-presenter-mate", mate)
                .then((res) => {})
                .catch((err) => {});
        },

        changeTimeZone({ code, label }) {
            Object.keys(this.agenda_slots).forEach((date) => {
                this.agenda_slots[date] = this.agenda_slots[date].map(
                    (slot) => {
                        const startTime = slot.start_time.replace(/\(.+\)/, "");
                        slot.start_time = this.convertTimeZone(
                            `${slot.date} ${startTime}`,
                            this.selectedTimeZone.code ||
                                this.default_timezone.code,
                            code
                        );
                        return slot;
                    }
                );
            });
            this.selectedTimeZone.code = code;
            this.selectedTimeZone.label = label;
        },

        convertTimeZone(date, oldTimeZone, newTimeZone) {
            const time = momentTZ.tz(date, oldTimeZone);
            const oldTime = time.format("L");
            time.tz("Europe/London");
            const londonTime = time.format("L");
            time.tz(newTimeZone);
            const newTime = time.format("L");
            const diff = moment(newTime).diff(moment(londonTime), "days");
            let res = time.format("HH:mm");
            if (diff) {
                res += "(" + (diff > 0 ? "+" : "") + diff + ")";
            }
            return res;
        },

        getCutOffDate() {
            Api()
                .post("auth/cut-off-date")
                .then((res) => {
                    let conference = JSON.parse(localStorage.conference);
                    conference.cut_off_date = res.data.cut_off_date;
                    localStorage.conference = JSON.stringify(conference);
                });
        },
        showSlot(date, closedDays){
            if(closedDays.includes(date)){
                if (this.old_available_slot && this.old_available_slot.length > 0){
                    return this.old_available_slot.includes(date);
                }
                return false;
            }
            return true;
        }
    },

    created() {
        if (
            !localStorage.getItem("registeration.client") &&
            !localStorage.getItem("client")
        ) {
            alert("Your session expired .... Please identify your self");
            this.$store
                .dispatch("endRegisrationProccess")
                .then(() => this.$router.push({ name: "Identify" }));
        }

        this.init();
        this.getSlotsAttendancePercentage();
        this.mapSelectedGroup(this.available_slot);
    },

    mounted() {
        this.disableSelectedSlots();
    },

    computed: {
        ...mapState(["timeZones"]),
        ...mapGetters(["conferenceTextData"]),
        groupedSlots() {
            let groups = [
                {
                    groupTitle: "Available on 4 & 5 March",
                    slots: {},
                    visible: true,
                },
                {
                    groupTitle: "Available on 6 & 7 March",
                    slots: {},
                    visible: true,
                },
                {
                    groupTitle: "Available on 8 & 9 March",
                    slots: {},
                    visible: true,
                },
            ];
            let nextGroup = groups[0];
            let index = 0;
            let group = 0;
            const closed_days = _.map(this.closed_days, (val) => val);
            _.each(this.agenda_slots, (timeslots, date) => {
                index++;
                if (this.showSlot(date, closed_days)) {
                    nextGroup.slots[date] = {
                        timeslots,
                        formattedDate: moment(date).format("DD-MM-YYYY"),
                    };
                }
                if (index % 2 == 0) {
                    group++;
                    nextGroup = groups[group];
                }
            });
            groups = _.filter(groups, (g) => _.keys(g.slots).length);
            // map morning and afternoon slots
            groups.forEach((group, index) => {
                // set group number after the above filtration
                group.groupNumber = ++index;

                let keys = Object.keys(group.slots);

                keys.forEach((key) => {
                    group.slots[key].morning_slots = group.slots[
                        key
                    ].timeslots.filter((slot) => slot.start_time < "13:00");

                    group.slots[key].afternoon_slots = group.slots[
                        key
                    ].timeslots.filter((slot) => slot.start_time >= "13:00");
                });
            });
            return groups;
        },
        afterCutoff() {
            const lateRegisterAvailableSLots = localStorage.getItem(
                "lateRegisterAvailableSLots"
            );
            let lateRegisterList;
            if (
                lateRegisterAvailableSLots &&
                lateRegisterAvailableSLots != "undefined"
            ) {
                lateRegisterList = JSON.parse(lateRegisterAvailableSLots);
            }
            if (!lateRegisterList || _.isEmpty(lateRegisterList)) return false;
            return true;
        },
        duringCutoff() {
            if (this.conference) {
                if (!this.conference.cut_off_date) return false;
                let now = moment().valueOf();
                return !moment(now).isBefore(this.conference.cut_off_date);
            }
            return false;
        },
    },
};
</script>

<style scoped>
.alert-btn {
    text-decoration: underline;
    font-style: italic;
    color: red;
}

.toltip-wrapper {
    position: relative;
}

.toltip {
    position: absolute;
    bottom: 30px;
    left: 0;
    background-color: black;
    text-align: center;
    color: white;
    z-index: 1;
    border-radius: 4px;
    padding: 2px 4px;
    width: 570px;
    display: none;
}

.absolute-full {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 10;
    cursor: pointer;
    height: 100%;
}

.toltip-wrapper:hover .toltip {
    display: block;
}

.back-red {
    background-color: red !important;
}

.flex {
    display: flex !important;
}
.justify-end {
    justify-content: flex-end !important;
}

.dimmed {
    background-color: #95a5a6;
    pointer-events: none;
    opacity: 0.5;
}

@media (max-width: 800px) {
    .scroll-sm {
        overflow: scroll;
    }
}
</style>
